export enum ErrorMessagesEnum {
  ResourceNotFound = 'We could not find the resource on the server',
  BadRequest = 'Your request did not have a valid format.',
  SignOut = 'Could not log you out. Please try again or report the issue to the administrator',
  SomethingWentWrong = 'Something went wrong',
  ReportToAdministrator = 'Please try again or report the issue to the administrator.',
  LoadProfile = 'We could not load your profile.',
  NotAuthenticated = 'You are not logged in or your credentials have expired.',
  Unknown = 'Something went wrong. Please try again or report the issue to the administrator.',
  EntitiesError = 'Could not fetch the entities definitions, some information might not be available.',
  CallsError = 'Could not fetch the calls.',
  CallError = 'Cound not fetch the required call resources.',
  ClaimHistoryError = 'Could not fetch claim history.',
  UpdateClaimStatusError = 'Could not update the claim status.',
  StartCall = 'Could not start the call.',
  CallExtractedEntities = 'Could not get the extracted entities, the information might not be accurate.',
  UpdateCallDisposition = 'Could not update the call disposition.',
  GetAudio = 'Could not get the audio recording.',
  CallTranscript = 'Could not get the call transcript.',
  CallNotes = 'Could not update the call notes.',
  ClaimEntityBag = 'Could not get the latest claim details.',
  SettingsSampleData = 'Could not update the sample data.',
}

export interface IErrorData {
  status: number
  title: string
  traceId: string
  detail?: string
  type?: string
  errors?: {
    [key: string]: string[]
  }
  [key: string]: unknown
}
